let ready = false;
let loading_script = false;

export function load_swiper(on_ready = null){

    if( swiper_script_ready(on_ready) ) return;
    
    if( has_elementor_swiper_elements() ) {
        // has elementor swiper, wait for elementor to load swiper.js
        check_elementor_swiper_ready(on_ready);
    }
    else {
        // load custom swiper js
        load_swiper_script();
    }
}

function swiper_script_ready(on_ready){

    if( typeof Swiper !== 'undefined' ) {

        swiper_ready();

        if( typeof on_ready === 'function' ) {
            on_ready();
        }

        return true;
    }

    return false
}

function has_elementor_swiper_elements(){
    return document.querySelector('.elementor-swiper, .e-widget-swiper') ? true : false;
}

function check_elementor_swiper_ready(on_ready){

    if( swiper_script_ready(on_ready) ) return;

    const checker = setInterval(function(){
        if( typeof Swiper !== 'undefined' ) {
            clearInterval(checker);
            swiper_ready();
        }
    }, 50);
}

function load_swiper_script(){

    if( loading_script ) return;
    loading_script = true;

    const script = document.createElement('script');
    script.src = window.location.origin+'/wp-content/plugins/elementor/assets/lib/swiper/v8/swiper.min.js?ver=8.4.5';
    script.onload = swiper_ready;
    document.body.appendChild(script);
}

function swiper_ready(){
    if( ready ) return;
    ready = true;
    document.dispatchEvent(new Event('swiper_ready'));
}